import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';
import jsonData from './color.json';

interface ColorData {
  colorId: number;
  slug: string;
  name: string;
}

const colorData: ColorData[] = toCamelCaseKeys(jsonData);

export const colors = (): ColorData[] => colorData;

export const color = ({ colorId }: { colorId: number }) => colorData.find((c) => c.colorId === colorId);
